import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=00c2499c&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00c2499c')) {
      api.createRecord('00c2499c', component.options)
    } else {
      api.reload('00c2499c', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=00c2499c&", function () {
      api.rerender('00c2499c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-26MWb6Cu2sH5d/JS/comp/ImgFallback.vue"
export default component.exports